import { Component, Inject } from "@angular/core"
import { FormControl, FormGroup, Validators } from "@angular/forms"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { GlossaryService } from "@app/api/api/glossary.service"
import { KeywordAndDefinitionPostRequestDto } from "@app/api/models/keyword-and-definition-post-request-dto"
import { KeywordAndDefinitionPutRequestDto } from "@app/api/models/keyword-and-definition-put-request-dto"
import { KeywordAndDefinition } from "@app/models/keywordAndDefinition"
import { HomeService } from "../../home.service"
import { catchError } from "rxjs"
import { HttpErrorResponse } from "@angular/common/http"

export interface CreateOrEditKeywordDialogComponentData {
  mode: 'create' | 'edit'
  languageCode: string
  allTags: string[]
  keywordAndDefinition?: KeywordAndDefinition
}

type CreateOrEditKeywordFormGroup = {
  keyword: FormControl<string | null>
  definition: FormControl<string | null>
  tag: FormControl<string | null>
}

@Component({
  selector: 'create-edit-keyword',
  templateUrl: './create-edit-keyword-dialog.component.html',
  styleUrls: ['./create-edit-keyword-dialog.component.scss']
})
export class CreateOrEditKeywordDialogComponent {

  CREATE_TITLE_LOCALIZED: string = $localize`:Create word translation|Translation for the word Create@@Create:Create`;
  EDIT_TITLE_LOCALIZED: string = $localize`:Edit word translation|Translation for the word Edit@@Edit:Edit`;

  mode: 'create' | 'edit' = 'create'
  languageCode!: string
  allTags: string[] = []
  keywordAndDefinition!: KeywordAndDefinition
  formGroup!: FormGroup<CreateOrEditKeywordFormGroup>

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CreateOrEditKeywordDialogComponentData,
    private _dialogRef: MatDialogRef<CreateOrEditKeywordDialogComponent>,
    private _homeService: HomeService
  ) {

    this.languageCode = data.languageCode,
    this.allTags = data.allTags.filter(t => t !== "N/A")
    if(!this.allTags.includes('CAMA')){
      this.allTags.push('CAMA');
    }
    data.mode === 'create' ? 
      (
        this.formGroup = new FormGroup<CreateOrEditKeywordFormGroup>({
          keyword: new FormControl(null, [Validators.required, Validators.maxLength(256)]),
          definition: new FormControl(null, Validators.required),
          tag: new FormControl('')
        })
      )
      :
      (
        this.mode = data.mode,
        this.keywordAndDefinition = data.keywordAndDefinition!,
        this.formGroup = new FormGroup<CreateOrEditKeywordFormGroup>({
          keyword: new FormControl(this.keywordAndDefinition.keyword, [Validators.required, Validators.maxLength(256)]),
          definition: new FormControl(this.keywordAndDefinition.definition, Validators.required),
          tag: new FormControl(this.keywordAndDefinition.tag)
        })
      )
  }

  /** */
  create() {
    const kadPostRequest: KeywordAndDefinitionPostRequestDto = {
      keyword: this.formGroup.controls.keyword.value!,
      definition: this.formGroup.controls.definition.value!,
      langCode: this.languageCode,
      domain: this.formGroup.controls.tag.value!,
    }

    this._homeService.createKeyword(kadPostRequest)
      .pipe(
        catchError((httpErrorResponse: HttpErrorResponse) => {
          const errorCode = httpErrorResponse.error.errorCode
          if(errorCode === 'VGLS1012') {
            this.formGroup.controls.keyword.setErrors({ duplicate: true })
          }
          throw new Error(httpErrorResponse.error)
        })
      )
      .subscribe(() => this._dialogRef.close());
  }

  /** */
  update() {

    const kadPutRequest: KeywordAndDefinitionPutRequestDto = {
      keywordId: this.keywordAndDefinition.keywordId,
      keyword: this.formGroup.controls.keyword.value!,
      definition: this.formGroup.controls.definition.value!,
      langCode: this.languageCode,
      domain: this.formGroup.controls.tag.value!,
    }

    this._homeService.updateKeyWord(kadPutRequest)
      .pipe(
        catchError((httpErrorResponse: HttpErrorResponse) => {
          const errorCode = httpErrorResponse.error.errorCode
          if(errorCode === 'VGLS1012') {
            this.formGroup.controls.keyword.setErrors({ duplicate: true })
          }
          throw new Error(httpErrorResponse.error)
        })
      )
      .subscribe(() => this._dialogRef.close());
  }

  /** */
  cancel() {
    this._dialogRef.close()
  }

}